import { resetHost } from '@/utils/url'

export const H5_VERSION = process.env.VUE_APP_H5_VERSION
export const SDK_VERSION = process.env.VUE_APP_SDK_VERSION
//判断是否在微信浏览器内
console.log('sdk_version', H5_VERSION, process.env.VUE_APP_H5_VERSION)
const MetaTag = {
    tagName: 'meta',
    key: 'rel',
    value: 'href',
}
const LinkTag = {
    tagName: 'link',
    key: 'name',
    value: 'content',
}
export const HeaderTagCorrespondenceList = {
    'apple-mobile-web-app-title': MetaTag,
    'apple-mobile-web-app-capable': MetaTag,
    'apple-touch-icon': LinkTag,
    'apple-touch-startup-image': LinkTag,
}

export const baseApiURL = resetHost(process.env.VUE_APP_API_URL)
